module.exports = __webpack_public_path__ + "img/avatar7.51cd16df.png";